import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Switch, FormControlLabel, FormHelperText } from '@mui/material';

// ----------------------------------------------------------------------

RHFSwitch.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
  label: PropTypes.string,
};

export default function RHFSwitch({ name, label, helperText, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          {/* <FormControlLabel control={<Switch {...field} checked={field.value} />} {...other} /> */}
          <FormControlLabel
            control={
              <Switch
                {...other}
                checked={!!field.value} // memastikan boolean
                onChange={(e) => field.onChange(e.target.checked)} // ambil `checked`
              />
            }
            label={label}
          />
          {(!!error || helperText) && (
            <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
          )}
        </div>
      )}
    />
  );
}
